import "./styles.scss";

import moment from "moment";
import { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";

import { MAX_SELECTABLE_TOPICS } from "../../HomeStudentStudyAI";

function ModalTopicsStudy({
  showModal,
  setShowModal,
  onNext = null,
  modalTopicsSource,
  selectedTopics = [],
  availableTopics = [],
  selectedTopicsForLimit = null,
  onSelectTopic = () => {},
  onUnselectTopic = () => {},
}) {
  const { t } = useTranslation();

  const [submitting, setSubmitting] = useState(false);

  const limitList = selectedTopicsForLimit ?? selectedTopics;
  const canSelectMore = limitList.length < MAX_SELECTABLE_TOPICS;

  const title =
    modalTopicsSource === "teacher" ? t("AI_PRACTICE_TEACHER_RECOMMEND") : t("AI_PRACTICE_TOPICS_AVAILABLE");

  const closeModal = () => setShowModal(false);

  const handleToggleTopic = (topic) => {
    const isSelected = selectedTopics.some((s) => s.id === topic.id);
    if (isSelected) {
      onUnselectTopic(topic.id);
      return;
    }

    if (!canSelectMore) return;
    onSelectTopic(topic.id);
  };

  const handleNext = async () => {
    if (!onNext) {
      closeModal();
      return;
    }

    try {
      setSubmitting(true);
      await onNext(selectedTopics);
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (limitList.length === MAX_SELECTABLE_TOPICS) closeModal();
    // eslint-disable-next-line
  }, [limitList]);

  return (
    <Dialog open={showModal} onClose={closeModal} className="modalTopicsStudy">
      <div className="containerTopicsStudy">
        <div className="topicsHeader">
          <h3 className="topicsTitle">{title}</h3>
        </div>

        <div className="topicsScroll">
          <div className="topics">
            {availableTopics.map((availableTopic, index) => {
              const cardLabel =
                modalTopicsSource === "teacher"
                  ? `${moment(availableTopic.classDateUTC).format(t("DATE_FORMAT"))} • ${availableTopic.dayOfWeek}
                  • ${availableTopic.startClassTimeUTC}
                  - ${availableTopic.endClassTimeUTC}
                  • ${t("TEACHER")}: ${availableTopic.teacherName}`
                  : `${t("LEVEL")}: ${availableTopic.level} • ${availableTopic.cycleName}`;

              return (
                <div key={index} className="topicsCard">
                  <p className="topicsCardTitle">{cardLabel}</p>

                  <div className="topicsCardWrapperButton">
                    {availableTopic.suggestedContents.map((suggestedContent) => {
                      const isSuggestedContentSelected = selectedTopics.some((item) => item.id === suggestedContent.id);

                      return (
                        <button
                          type="button"
                          key={suggestedContent.id}
                          disabled={!isSuggestedContentSelected && !canSelectMore}
                          onClick={() => handleToggleTopic(suggestedContent)}
                          className={isSuggestedContentSelected ? "topicChip topicChipSelected" : "topicChip"}
                        >
                          <span className="chipLabel">{suggestedContent.classTitle}</span>
                          <span className="chipRemove">×</span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="topicsFooter">
          <button className="cancelButton" onClick={closeModal}>
            {t("BACK")}
          </button>

          <button
            type="button"
            onClick={handleNext}
            className="topicsNextBtn"
            disabled={submitting || selectedTopics.length === 0}
          >
            Next
          </button>
        </div>
      </div>
    </Dialog>
  );
}

export default ModalTopicsStudy;
